module.exports = {
  development: {
    baseUrl: "/api",
    // mockUrl: "https://www.goodee-service.com",
    mockUrl: "http://localhost:8000",
    // mockUrl: "http://172.3.1.2:8081",
  },
  production: {
    baseUrl: "/api",
    // mockUrl: "https://www.goodee-service.com",
    mockUrl: "http://localhost:8000",
  },
};
